export default __webpack_public_path__ + "static/media/ApplePay.4a5830ab.svg";